import { Breakpoints } from "@angular/cdk/layout";

export namespace ResponsiveConstants {
  export
    const SIZE_LAYOUT_ARR = [
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge,
    ]

  export
    const SCREEN_SIZE_LAYOUT_MAP = new Map<string, ScreenSizeType>([
      [Breakpoints.XSmall, 'XSmall'],
      [Breakpoints.Small, 'Small'],
      [Breakpoints.Medium, 'Medium'],
      [Breakpoints.Large, 'Large'],
      [Breakpoints.XLarge, 'XLarge'],
    ]);
};

export type ScreenSizeType = 'XSmall' | 'Small' | 'Medium' | 'Large' | 'XLarge' | 'Unknown';
